export default __webpack_public_path__ + "static/media/ico_trash_gray.c20994fe.svg";